// Service worker registration with update-available hooks.
// Wired up from src/index.js — call register() once at boot.

const isLocalhost = Boolean(
  typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname))
);

export function register(callbacks = {}) {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;

  const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    if (isLocalhost) {
      checkValidServiceWorker(swUrl, callbacks);
    } else {
      registerValidSW(swUrl, callbacks);
    }
  });

  window.addEventListener('appinstalled', () => {
    window.__deferredInstallPrompt = null;
    if (callbacks.onAppInstalled) callbacks.onAppInstalled();
  });
}

function registerValidSW(swUrl, callbacks) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (installing.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content available; existing tab still serving old version.
              if (callbacks.onUpdate) callbacks.onUpdate(registration);
            } else {
              // First install — content is cached for offline use.
              if (callbacks.onSuccess) callbacks.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((err) => {
      console.error('SW registration failed:', err);
    });
}

function checkValidServiceWorker(swUrl, callbacks) {
  // On localhost, verify the SW file is reachable before registering — avoids stale SW from a previous app.
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const ct = response.headers.get('content-type') || '';
      if (response.status === 404 || !ct.includes('javascript')) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, callbacks);
      }
    })
    .catch(() => {
      // Offline at first load — nothing to do.
    });
}

export function unregister() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((err) => console.error(err));
}

